import { render } from "./homeworkView.vue?vue&type=template&id=4d377f01"
import script from "./homeworkView.vue?vue&type=script&lang=js"
export * from "./homeworkView.vue?vue&type=script&lang=js"

import "./homeworkView.vue?vue&type=style&index=0&id=4d377f01&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__